var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M860.66 2157.32H581.77v102.25h278.89v-102.25",
    style: {
      fill: "#e14f21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.961 2955.87s-14.32 4.95 4.961 75.03c5.973 21.7 50.039 5.89 64.379-6.27 0 0-13.539-78.04-34.156-77.19l-35.184 8.43",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.68 3023.41c-1.098-4.8 1.25-9.46 5.293-10.42 4.043-1 8.203 2.05 9.316 6.85l17.012 73.97c1.101 4.79-1.274 9.43-5.313 10.44-4.07.94-8.179-2.1-9.312-6.84l-16.996-74m-23.242-.1c-.965-4.79 1.566-9.33 5.644-10.15 4.082-.8 8.148 2.39 9.098 7.21l14.785 74.49c.937 4.81-1.578 9.36-5.645 10.16-4.093.8-8.16-2.4-9.121-7.19l-14.761-74.52",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.965 1907.97h-49.391v393.98h49.391v-393.98m754.055 0h49.39v393.98h-49.39v-393.98",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.49 2242.75H298.152v83.97h805.338v-83.97",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.41 2269.57H280.574v81.91h852.836v-81.91",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.938 2278.71H583.617v54.44h267.321v-54.44",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.141 2237.93c-32.203 7.09-64.039-13.5-71.067-45.98l-53.191-238.94 121.344-7.95 48.441 221.19c7.051 32.52-13.375 64.59-45.527 71.68m209.554-57.27c-.875 33.23-28.304 59.5-61.207 58.66-32.925-.88-58.957-28.58-58.109-61.82l6.301-225.43 121.054-4.63-8.039 233.22",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.043 1954.59c-4.703 11.82-98.891 17.69-119.488 3.44-6.559-4.5-10.2-34.32-10.2-34.32h135.684s-2.285 21.54-5.996 30.88",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.039 1907.97H744.355v15.74h135.684v-15.74",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.559 1954.59c4.703 11.82 98.961 17.69 119.504 3.44 6.531-4.5 10.292-34.32 10.292-34.32H521.637s2.234 21.54 5.922 30.88",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.637 1907.97h135.718v15.74H521.637v-15.74",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.617 2482.3-18.449-54.58 74.348-96.06 20.738 14.57-76.637 136.07",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.328 2301.72s-11.406 10.47-8.699 13.55c4.324 5.02 18.828-16.58 24.965-7.57 5.004 7.28-11.254 10.07-19.653 22.77-16.402 24.86-29.144 21.68-29.144 21.68l-20.641-13.52s27.481-50.64 30.961-54.04c2.891-2.81 15.52-15.82 31.613-25.02.665-.39 8.11 16.17 8.438 24.4.469 11.85-17.84 17.75-17.84 17.75",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.023 2732.83s-298.414-74.96-320.253-107.31c-23.317-34.57-85.282-124.31-89.774-161.38-2.23-18.87 41.281-79.41 83.734-132.48l31.524 34.79-45.461 101.94s66.305 87.95 79.449 107.41l92.285 44.43 168.496 112.6",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.117 3004.65c-85.765-11.29-146.179-89.9-134.945-175.63 0 0 75.058 26.58 153.191 36.83 91.93 12.03 157.422 3.88 157.422 3.88-11.258 85.77-89.93 146.16-175.668 134.92",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.379 2843.82c2.238-8.18-2.344-16.76-10.316-19.05-8.016-2.25-16.45 2.2-19.036 10.38-2.543 8.11 2 16.92 10.321 19.24 8.246 2.41 16.738-2.3 19.031-10.57m29.644 7.62c1.997-8.3-2.937-16.46-10.953-18.65-7.988-2.11-16.386 2.85-18.691 11.03-2.274 8.21 2.641 16.65 10.887 18.86 8.394 2.27 16.785-2.97 18.757-11.24",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.906 2858.05c1.692-8.38-3.554-16.35-11.636-18.2-8.024-1.88-16.2 3.31-18.247 11.59-2.019 8.27 3.157 16.59 11.547 18.54 8.383 1.93 16.711-3.61 18.336-11.93",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.016 2863.48c1.293-8.5-4.258-16.25-12.36-17.66-8.066-1.58-16.011 3.87-17.75 12.23-1.718 8.34 3.754 16.52 12.223 18.16 8.559 1.49 16.644-4.32 17.887-12.73",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.34 2867.5c.918-8.52-5.008-16.06-13.235-16.98-8.113-1.26-15.722 4.5-17.089 12.96-1.34 8.41 4.515 16.31 13.117 17.63 8.597.98 16.289-5.15 17.207-13.61",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.805 2870.29c.586-8.55-5.641-15.74-13.848-16.5-8.18-.89-15.609 5.21-16.617 13.71-.988 8.46 5.195 16.05 13.797 17.01 8.625.85 16.078-5.78 16.668-14.22",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.359 2871.93c.215-8.57-6.265-15.56-14.48-15.97-8.176-.63-15.418 5.84-16.074 14.33-.617 8.54 5.824 15.89 14.449 16.48 8.633.5 15.848-6.37 16.105-14.84",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.941 2872.29c-.097-8.52-6.863-15.4-15.117-15.38-8.183-.13-15.136 6.49-15.465 15.02-.304 8.47 6.493 15.68 15.164 15.84 8.625 0 15.563-6.91 15.418-15.48",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.547 2871.32c-.59-8.46-7.594-14.97-15.801-14.74-8.195.35-14.848 7.22-14.805 15.71.071 8.55 7.125 15.54 15.821 15.15 8.672-.25 15.304-7.59 14.785-16.12m5.215 47.44c3.785 1.9 8.023 2.1 11.926.68 3.593-1.53 6.765-4.67 8.457-8.93 1.804-4.16 1.273-8.69-.586-12.33-1.856-3.59-5.129-6.29-9.239-7.36-4.066-1.11-8.3-.57-11.66 1.03-3.32 1.65-5.851 4.3-7.383 7.72-1.406 3.44-1.054 7.23.567 10.72 1.359 3.37 4.047 6.57 7.918 8.47",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.016 2944.14c3.293 2.59 7.57 3.65 11.566 2.95 3.805-.78 7.547-3.27 10.016-7.13 2.605-3.71 2.789-8.37 1.757-12.18-1.101-3.87-3.773-7.14-7.593-9.02a16.964 16.964 0 0 0-11.649-1.22c-3.769.88-6.562 3.14-8.75 6.15-2.066 3.11-2.402 6.88-1.527 10.65a16.425 16.425 0 0 0 6.18 9.8",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.664 2966.07c2.793 3.19 6.793 5.04 10.785 5.08 3.926-.08 8.059-1.76 11.211-5.02 3.293-3.2 4.371-7.71 4.094-11.7-.383-4.03-2.379-7.7-5.738-10.29-3.383-2.53-7.543-3.63-11.305-3.44-3.809.22-6.981 1.9-9.688 4.43-2.628 2.66-3.757 6.28-3.593 10.14.113 3.73 1.383 7.61 4.234 10.8",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.57 2983.83c2.129 3.59 5.731 6.2 9.629 6.95 3.891.68 8.254-.21 11.969-2.82 3.84-2.47 5.738-6.72 6.207-10.69.371-4-.844-8.01-3.711-11.2-2.82-3.16-6.637-4.98-10.371-5.49-3.785-.56-7.191.51-10.391 2.49-3.031 2.09-4.812 5.48-5.382 9.27-.59 3.75-.141 7.75 2.05 11.49",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.578 2996.6c1.418 3.94 4.352 7.21 8.094 8.66 3.68 1.46 8.18 1.39 12.308-.49 4.258-1.66 6.844-5.57 8.063-9.28 1.199-3.87.691-8.05-1.473-11.66-2.172-3.69-5.64-6.23-9.191-7.4-3.574-1.3-7.176-.88-10.606.46-3.41 1.51-5.851 4.44-7.078 8.06-1.293 3.62-1.621 7.59-.117 11.65",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.602 3004.02c.628 4.18 2.984 7.99 6.296 10.03 3.336 2.14 7.711 2.92 12.227 1.91 4.461-.84 7.801-4.18 9.648-7.64 1.934-3.55 2.286-7.71.805-11.72-1.476-4.03-4.324-7.11-7.613-8.99-3.317-2-6.863-2.18-10.559-1.56-3.617.79-6.504 3.23-8.457 6.55-1.929 3.36-3.008 7.14-2.347 11.42",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.723 3005.78c-.453 8.74 6.672 15.45 15.914 15.27 9.164-.72 15.441-8.71 13.965-17.03-1.465-8.49-8.516-14.31-15.801-13.81-7.285.08-13.586 7.35-14.078 15.57",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.078 3001.87c-2.047 8.29 3.625 16.39 12.723 18.01 9.164.84 16.781-5.56 16.922-14.1.183-8.51-5.571-15.92-12.813-16.48-7.265-1.41-14.781 4.32-16.832 12.57",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.73 2992.38c-3.621 7.66.352 16.93 9.079 20.04 8.816 2.57 17.507-2.03 19.269-10.55 1.715-8.15-2.515-16.75-9.469-18.73-6.867-2.47-15.257 1.41-18.879 9.24",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.715 2977.6c-4.961 6.81-2.969 16.79 5.07 21.46 8.137 4.3 17.512 1.33 20.945-6.68 3.27-7.66.75-16.83-5.761-20.21-6.34-3.67-15.137-1.53-20.254 5.43",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.008 2958.2c-3.086 2.89-4.637 6.82-4.496 10.84.191 3.95 1.695 8.34 5.316 11.1 3.524 2.89 7.914 4.13 11.793 3.66 3.906-.35 7.692-2.75 10.094-6.2 2.531-3.56 3.191-7.39 2.91-11.33-.262-3.77-1.832-7.29-4.727-9.57-5.523-4.77-14.621-4.4-20.89 1.5",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.367 2934.79c-3.605 2.32-5.84 5.85-6.465 9.82-.566 3.86.086 8.56 3.145 11.95 2.918 3.48 6.883 5.49 10.84 5.85 3.922.34 8.105-1.32 11.121-4.21 3.097-3 4.531-6.72 5.019-10.57.403-3.76-.418-7.47-2.855-10.33-2.477-2.75-5.488-4.72-9.363-5.12-3.739-.44-7.879.28-11.442 2.61",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.465 2908.34c-3.914 1.58-6.817 4.61-8.18 8.4-1.289 3.69-1.547 8.42.824 12.31 2.215 3.96 5.789 6.71 9.567 7.77 3.769 1.1 8.183.27 11.691-2.03 3.641-2.37 5.754-5.69 6.934-9.38 1.144-3.69 1.027-7.42-.774-10.66-2.097-3.21-4.593-5.68-8.273-6.82a16.772 16.772 0 0 0-11.789.41",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.914 2879.69c-4.184.8-7.594 3.22-9.637 6.66-2.047 3.4-3.148 8.01-1.547 12.28 1.399 4.33 4.368 7.72 7.864 9.48 3.554 1.73 8.019 1.78 11.871.23 4.023-1.66 6.754-4.53 8.578-7.89 1.816-3.44 2.402-7.15 1.273-10.66-1.41-3.52-3.402-6.41-6.765-8.25-3.266-1.87-7.457-2.67-11.637-1.85",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 2849.88c-4.234.08-8.066 1.8-10.789 4.75-2.684 2.97-4.563 7.24-3.813 11.74.524 4.58 2.75 8.42 5.907 10.84 3.211 2.36 7.468 3.28 11.609 2.48 4.231-.84 7.52-3.2 9.844-6.12 2.496-3 3.84-6.53 3.34-10.24-.61-3.64-2.207-6.96-5.075-9.35-2.863-2.43-6.765-4.08-11.023-4.1m307.32 40.94-.754-.27-.746-.26-.707-.35-.664-.33-.66-.47-.676-.44-.586-.5-.562-.59-.543-.52-.5-.61-.488-.65-.45-.63-.449-.67-.418-.73-.351-.72-.215-.42-.117-.22-.028-.08-.023-.04v-.02h-.02v-.03c.305.17.305.17.45.24l-.586-.64-.028-.01-.051-.02-.039-.04-.078-.06-.14-.15-.395-.22-.609-.53-.703-.56-.637-.51-.543-.65-.535-.58-.504-.64-.445-.65-.446-.71-.324-.68-.363-.73-.254-.73-.258-.78-.113-.72-.145-.75-.07-.83v-1.57l.051-.8.164-.73.156-.76.266-.74.254-.74.312-.73.371-.74.352-.64.476-.69.469-.67.539-.64.539-.63.633-.57.594-.58.582-.57.726-.52 1.438-.98.758-.49.746-.45.82-.42.852-.31.871-.39.886-.36.903-.27.91-.25 1.832-.4.875-.17.914-.14.984-.06 1.039-.07 1.032-.03 1.011-.02.938.05.965.12.98.1.926.17.894.17.887.26.875.25.867.33.875.32.774.39.773.4.758.4.434.73.363.77.375.82.332.8.273.92.215.85.254.91.172.9.164.94.113.93.094 1 .047.96.023 1.01-.043.98-.074 1.01-.093 1.04-.254 1.23-.266 1.14-.32 1.16-.34 1.1-.371 1.08-.375 1.09-.446 1.05-.515.98-.422.99-.566.92-.497.9-.566.82-.633.82-.558.8-.637.7-.656.64-.657.65-.777.57-.73.5-.782.44-.75.45-.773.36-.754.35-.824.2-.746.24-.782.17-.871.06-.75.1-.82-.06-.777-.06-.746-.13-.782-.16m-287.293-55.67-.257.75-.305.7-.36.75-.371.67-.449.65-.469.62-.511.57-.551.57-.606.53-.66.5-.609.45-.684.45-.699.43-.738.39-.746.34-.43.15-.211.03-.109.09v.03h-.051l-.02.03-.664.39c.239-.04.196-.04.375-.04l-.047-.02v.06l-.05.03-.012.07-.148.16-.309.3-.625.62-.551.56-.605.54-.61.49-.59.47-.679.41-.68.45-.707.35-.711.3-.656.27-.84.23-.711.2-.793.1-.777.09h-1.602l-.781-.11-.742-.08-.805-.2-.723-.21-.757-.33-.707-.36-.746-.4-.641-.42-.703-.47-.637-.54-.652-.59-.637-.6-.539-.72-.332-.35-.184-.37-.515-.73-.453-.82-.446-.82-.351-.88-.328-.92-.375-.94-.286-.95-.312-1.04-.223-1.01-.148-1.12-.164-1.03-.145-1.13-.043-1.1-.047-1.15-.019-1.15.066-1.15.067-1.18.144-1.01.192-.94.203-.92.312-.94.231-.84.332-.91.375-.85.371-.83.457-.79.441-.78.469-.68.469-.76.519-.66.496-.69.629-.61.571-.6.82-.27.805-.24.839-.12.848-.21.871-.1.895-.1.918-.04h1.785l.918.12.887.06.925.16.938.17.887.24 1.011.26.844.32.992.32.891.43.754.34.918.48.797.44.8.45.778.51.769.55.684.57.726.6.641.59.66.6.543.67.563.68.496.68.539.68.441.65.403.78.417.71.313.73.305.77.257.76.235.75.14.77.125.79.129.77.032.75-.043.8-.086.77-.114.8-.14.78-.231.73",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.258 2875.09c8.527-64.76-45.867-125.21-121.442-135.12-75.543-9.94-143.687 34.48-152.179 99.23-8.481 64.68 45.906 125.14 121.484 135.04 75.547 9.91 143.692-34.51 152.137-99.15",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.883 2867.77c1.015-7.63-4.418-14.68-12.074-15.7-7.649-1.01-14.645 4.42-15.661 12.06-1.011 7.65 4.372 14.67 12.036 15.66 7.617 1.03 14.695-4.4 15.699-12.02",
    style: {
      fill: "#754c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.813 2870.2c.445-3.17-1.782-6.1-4.918-6.49-3.215-.45-6.153 1.8-6.571 4.98-.406 3.17 1.824 6.07 5.047 6.49 3.176.41 6.039-1.78 6.442-4.98",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.391 2878.87a14.02 14.02 0 0 0-12.051-15.73c-7.621-.99-14.695 4.4-15.703 12.07-.989 7.63 4.461 14.68 12.058 15.67 7.657.98 14.66-4.42 15.696-12.01",
    style: {
      fill: "#754c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.082 2879.53c.398-3.15 3.32-5.41 6.465-5a5.81 5.81 0 0 1 5.035 6.49 5.783 5.783 0 0 1-6.562 4.98c-3.125-.39-5.36-3.3-4.938-6.47",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.926 2817.07c1.367-10.32-5.969-19.78-16.289-21.15-10.414-1.37-19.817 5.92-21.153 16.23-1.359 10.35 5.868 19.84 16.262 21.21 10.324 1.37 19.82-5.96 21.18-16.29m221.785 29.06c1.34-10.33 10.836-17.59 21.129-16.27 10.367 1.41 17.68 10.88 16.312 21.2-1.359 10.35-10.859 17.63-21.23 16.29-10.309-1.33-17.578-10.86-16.211-21.22",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.949 2892.71c-12.945-1.69-23.578-7.69-28.316-14.94 0 0 12.969 9.5 28.789 11.59 16.687 2.2 30.891-3.77 30.891-3.77-6.465 5.81-18.215 8.82-31.364 7.12m90.035 11.82c-12.953-1.71-23.597-7.7-28.375-14.97 0 0 12.954 9.5 28.821 11.57 16.672 2.21 30.886-3.74 30.886-3.74-6.511 5.78-18.265 8.84-31.332 7.14",
    style: {
      fill: "#754c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m692.434 2759.83 9.636-73.5 40.805 5.34-9.633 73.53-40.808-5.37",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.52 2817.82c.328-2.23-1.223-4.21-3.407-4.52-2.144-.25-4.211 1.25-4.468 3.5-.282 2.15 1.269 4.15 3.41 4.46 2.207.25 4.203-1.28 4.465-3.44m-11.352-12.66a2.782 2.782 0 0 0-2.449-3.14c-1.504-.2-2.938.87-3.121 2.4a2.863 2.863 0 0 0 2.398 3.25 2.838 2.838 0 0 0 3.172-2.51m-.262 23.86c.164-1.58-.89-3.02-2.441-3.21a2.83 2.83 0 0 0-3.168 2.47c-.219 1.52.887 2.91 2.433 3.13a2.856 2.856 0 0 0 3.176-2.39m23.157.13c.183-1.57-.895-2.94-2.446-3.17-1.601-.17-3.008.89-3.219 2.44-.238 1.58.891 2.97 2.461 3.18a2.835 2.835 0 0 0 3.204-2.45m-1.434-21.16c.211-1.54-.867-2.95-2.445-3.17-1.547-.2-2.942.92-3.145 2.43-.215 1.6.863 3 2.414 3.2 1.551.19 2.942-.88 3.176-2.46m-10.32 25.1c.164-.98-.52-1.87-1.532-1.99-.937-.13-1.824.54-1.964 1.52-.122 1.02.535 1.84 1.496 1.99 1.035.14 1.906-.55 2-1.52m-17.321-15.77c.09-1-.597-1.87-1.605-2.04-.957-.11-1.828.57-1.969 1.56-.148.98.609 1.85 1.496 1.99 1.012.1 1.914-.54 2.078-1.51m15.231-15.6c.16-.96-.571-1.84-1.578-2-.914-.09-1.864.56-1.946 1.53-.144.99.582 1.87 1.5 1.99.989.16 1.879-.58 2.024-1.52m16.023 16.1c.149-.95-.512-1.84-1.5-2-1.015-.12-1.902.57-2.019 1.53-.145.97.535 1.88 1.57 2.01.969.11 1.836-.6 1.949-1.54m152.914 22.04c.285-2.13-1.246-4.22-3.429-4.47-2.215-.31-4.231 1.31-4.497 3.45-.324 2.18 1.247 4.16 3.442 4.46 2.18.28 4.203-1.22 4.484-3.44m-11.398-12.59c.207-1.57-.848-2.95-2.422-3.15-1.531-.23-2.984.87-3.152 2.4-.239 1.55.89 2.97 2.425 3.17 1.575.21 2.938-.89 3.149-2.42m-.238 23.77c.214-1.55-.868-2.96-2.465-3.17-1.512-.19-2.914.88-3.153 2.44-.164 1.55.918 2.96 2.446 3.17 1.578.19 2.988-.88 3.172-2.44m23.132.18c.207-1.53-.918-2.96-2.472-3.17-1.621-.18-2.961.9-3.168 2.45-.164 1.55.843 2.96 2.418 3.17 1.554.19 3.011-.92 3.222-2.45m-1.406-21.16a2.92 2.92 0 0 0-2.433-3.17 2.844 2.844 0 0 0-3.165 2.43c-.187 1.57.868 3 2.422 3.2 1.547.18 2.942-.9 3.176-2.46m-10.305 25.09c.118-.96-.558-1.86-1.5-1.97-1.035-.15-1.882.54-2.023 1.5-.137.98.562 1.88 1.531 2 .961.12 1.852-.54 1.992-1.53m-17.367-15.79c.117-.94-.566-1.84-1.547-2.01-.968-.08-1.886.57-1.976 1.56-.145.98.539 1.85 1.496 1.97.969.14 1.887-.55 2.027-1.52m15.258-15.59a1.787 1.787 0 0 0-1.551-1.97c-.965-.15-1.906.56-2.047 1.48-.14 1.01.61 1.95 1.567 2.06.969.15 1.887-.57 2.031-1.57m16.004 16.09c.121-1-.59-1.84-1.555-1.99-.91-.12-1.828.57-1.968 1.55-.118.95.613 1.89 1.531 2.01.957.11 1.851-.59 1.992-1.57",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.387 2903.93c-20.688-2.71-35.262-21.72-32.578-42.43 2.726-20.64 21.714-35.26 42.402-32.55 20.687 2.75 35.266 21.71 32.559 42.37-2.704 20.71-21.743 35.33-42.383 32.61zm10.547-80.77c-23.832-3.12-45.762 13.73-48.911 37.58-3.101 23.89 13.727 45.8 37.582 48.95 23.86 3.12 45.821-13.73 48.918-37.62 3.133-23.86-13.707-45.78-37.589-48.91m93.39 94.4c-20.676-2.74-35.316-21.74-32.594-42.45 2.696-20.62 21.758-35.25 42.446-32.51 20.621 2.7 35.234 21.72 32.558 42.33-2.703 20.73-21.742 35.33-42.41 32.63zm10.61-80.76c-23.864-3.13-45.864 13.72-48.965 37.56-3.149 23.9 13.75 45.81 37.633 48.94 23.836 3.13 45.765-13.71 48.89-37.62 3.129-23.81-13.726-45.79-37.558-48.88",
    style: {
      fill: "#b63633",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m709.164 2869.73-20.918-2.76-.769 5.81 20.914 2.73.773-5.78m84.93 14.12-4.989 3.04 25.559 42.19 4.953-3.02-25.523-42.21m-189.199-24.81-41.024 39.48 4.024 4.18 40.968-39.44-3.968-4.22",
    style: {
      fill: "#b63633",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.934 2960.55c1.222-9.23-5.309-17.68-14.532-18.87-9.23-1.2-17.695 5.26-18.886 14.49-1.227 9.22 5.289 17.64 14.519 18.86 9.192 1.2 17.653-5.26 18.899-14.48",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.664 2959.75c1.195-9.18-5.266-17.67-14.504-18.85-9.265-1.22-17.726 5.31-18.922 14.49-1.222 9.25 5.285 17.68 14.524 18.89 9.218 1.23 17.699-5.27 18.902-14.53m-51.781-46.89c1.187-9.24-5.32-17.72-14.559-18.95-9.238-1.2-17.699 5.32-18.894 14.55-1.207 9.22 5.258 17.65 14.48 18.88 9.258 1.2 17.746-5.32 18.973-14.48",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.219 2934.7c1.195-9.21-5.289-17.71-14.504-18.9-9.285-1.23-17.676 5.29-18.902 14.5-1.196 9.23 5.246 17.73 14.484 18.95 9.238 1.2 17.719-5.31 18.922-14.55",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.918 2948.4c1.195-9.26-5.316-17.72-14.559-18.9-9.211-1.22-17.648 5.27-18.847 14.5-1.215 9.22 5.265 17.68 14.48 18.91 9.219 1.17 17.723-5.29 18.926-14.51m60.102 26.37c1.199-9.23-5.266-17.65-14.477-18.87-9.262-1.19-17.754 5.26-18.945 14.48-1.227 9.26 5.265 17.74 14.523 18.95 9.242 1.2 17.676-5.27 18.899-14.56",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.254 2972.85c1.297-9.86-5.664-18.97-15.555-20.23-9.922-1.35-18.996 5.7-20.269 15.52-1.289 9.91 5.644 19 15.562 20.29 9.903 1.3 18.973-5.7 20.262-15.58",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.051 2954.79c.937-7.26-4.133-13.91-11.418-14.85-7.262-.96-13.895 4.14-14.86 11.45-.937 7.18 4.161 13.86 11.43 14.83 7.258.94 13.914-4.17 14.848-11.43",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.754 2962.62c1.219-9.24 9.637-15.73 18.875-14.52 9.215 1.2 15.75 9.65 14.551 18.89-1.2 9.22-9.707 15.69-18.918 14.5a16.827 16.827 0 0 1-14.508-18.87",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.438 2967.32c1.199-9.17 9.71-15.68 18.906-14.45 9.238 1.17 15.75 9.65 14.574 18.85-1.227 9.26-9.758 15.74-18.977 14.53-9.164-1.21-15.726-9.65-14.503-18.93m62.152-31.95c1.203-9.22 9.687-15.77 18.922-14.55 9.218 1.2 15.73 9.67 14.523 18.91-1.187 9.19-9.68 15.72-18.894 14.5-9.239-1.18-15.746-9.68-14.551-18.86",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.105 2952.77c1.2-9.22 9.708-15.72 18.875-14.53 9.211 1.23 15.75 9.69 14.528 18.93-1.223 9.22-9.66 15.7-18.875 14.5-9.219-1.22-15.75-9.69-14.528-18.9",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.535 2960.93c1.199-9.24 9.692-15.75 18.883-14.54 9.211 1.19 15.727 9.7 14.523 18.93-1.199 9.19-9.687 15.69-18.925 14.47-9.161-1.18-15.672-9.65-14.481-18.86m-29.332-162.9.961-7.33s38.387 2.56 57.926 27.12c0 0-22.832-15.09-58.887-19.79",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m708.203 2798.03.961-7.33s-37.769-7.43-62.949 11.25c0 0 25.93-8.67 61.988-3.92m2.399-18.29.984-7.43s26.59 3.49 33.43 16.49c0 0-19.934-7.37-34.414-9.06",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m710.602 2779.74.984-7.43s-26.629-3.48-36.547 7.31c0 0 21.082-1.96 35.563.12m47.101 40.42c5.293-3.66 7.645-2.02 13.453-13.48 0 0-1.25 13.32-9.996 16.76-4.887 2.03-4.953-2.21-3.457-3.28m-103.023-13.5c-4.184-4.89-6.864-3.93-9.567-16.5 0 0-2.23 13.18 5.356 18.79 4.16 3.19 5.359-.88 4.211-2.29",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.824 2351.25h-119.39l-1.379 296.85 120.769 28.71v-325.56m0 0 146.91.23v250.06s-.703 125.95-23.906 112.88c-22.75-12.82-121.437-25.4-121.437-25.4l-1.567-337.77",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.391 2351.25h-10.953v337.77h10.953v-337.77",
    style: {
      fill: "#d8d1d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.527 2705.93c-16.222 8.82-59.336 29.95-60.672 7.08-.355-5.65 4.559-15.84 4.09-21.42.469-5.61-4.445-15.75-4.09-21.41 1.29-22.65 43.278-2.33 59.938 6.66-6.152 20.54.734 29.09.734 29.09m74.02 7.08c-1.289 22.87-44.481 1.74-60.672-7.08 0 0 6.891-8.46.711-29.09 16.656-8.99 58.672-29.31 59.961-6.66.305 5.66-4.539 15.8-4.09 21.41-.449 5.58 4.395 15.77 4.09 21.42",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.875 2705.93h-13.348s-6.886-8.55-.734-29.09v-.03h14.793v.03c6.18 20.63-.711 29.09-.711 29.09",
    style: {
      fill: "#f46d73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.535 2644.47c0-2.03-1.597-3.67-3.594-3.67a3.665 3.665 0 0 0-3.66 3.67c0 2.01 1.641 3.63 3.66 3.63 1.997 0 3.594-1.62 3.594-3.63m0-61.76c0-2.03-1.597-3.65-3.594-3.65a3.647 3.647 0 0 0-3.66 3.65c0 1.97 1.641 3.59 3.66 3.59a3.592 3.592 0 0 0 3.594-3.59m0-61.78c0-1.99-1.597-3.61-3.594-3.61-2.019 0-3.66 1.62-3.66 3.61 0 2.03 1.641 3.65 3.66 3.65 1.997 0 3.594-1.62 3.594-3.65m0-61.72c0-2.03-1.597-3.65-3.594-3.65a3.647 3.647 0 0 0-3.66 3.65c0 2 1.641 3.6 3.66 3.6 1.997 0 3.594-1.6 3.594-3.6m0-61.75c0-2.01-1.597-3.67-3.594-3.67-2.019 0-3.66 1.66-3.66 3.67 0 1.99 1.641 3.59 3.66 3.59a3.58 3.58 0 0 0 3.594-3.59",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.359 2659.84c-6.726-20.82-13.996-59.4-13.996-59.4l50.051-153.94c31.5 136.19 42.734 191.58 48.676 213.34 28.773 105.36 68.289 287.45 68.289 287.45.23 1.46.281 2.55.402 3.78l-75.273 19.46s-53.008-232.77-78.149-310.69",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.164 2360.62c1.346-8.24 9.096-13.86 17.366-12.52 8.3 1.31 13.89 9.07 12.58 17.35l-.16.88-29.923-4.83.137-.88",
    style: {
      fill: "#f26522",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m999.027 2361.5 29.923 4.83-2.71 16.91-29.939-4.82 2.726-16.92",
    style: {
      fill: "#808285",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m996.301 2378.42 29.939 4.82-24.59 152.5-29.939-4.85 24.59-152.47",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m970.934 2535.81.777-4.92 29.939 4.85-.7 4.22-12.829 25.74-13.07-2.09-4.117-27.8",
    style: {
      fill: "#ffdeb5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m975.051 2563.61 13.07 2.09-9.828 19.7z",
    style: {
      fill: "#808285",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.2 2552.55c2.58 7.95-.84 16.21-7.71 18.46-6.89 2.27-14.53-2.36-17.16-10.31l-.26-.86 24.87-8.13.26.84",
    style: {
      fill: "#f26522",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1106.94 2551.71-24.87 8.13-5.34-16.27 24.87-8.15 5.34 16.29",
    style: {
      fill: "#808285",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1101.6 2535.42-24.87 8.15-48.09-146.79 24.85-8.13 48.11 146.77",
    style: {
      fill: "#379bc2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051.94 2383.91 1.55 4.74-24.85 8.13-1.34-4.05-1.5-28.41 10.83-3.56 15.31 23.15",
    style: {
      fill: "#ffdeb5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1036.63 2360.76-10.83 3.56-1.21-21.74z",
    style: {
      fill: "#808285",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.19 2437.97h-79.48v-118.34h47.37l32.11 118.34",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.27 2437.97h79.46v-118.34h-47.371l-32.089 118.34",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06181 0 0 -.06181 8.8 191.936)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent6);
export default __webpack_public_path__ + "static/media/student6.9ffcf94bf502699cb7d2b3304b9586ca.svg";
export { ForwardRef as ReactComponent };